import Vue from "vue";
import Vuelidate from "vuelidate";
import linkify from "vue-linkify";
import { onLCP, onFID, onCLS } from "web-vitals";

import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";

if (process.env.VUE_APP_MODE != "development") {
  Bugsnag.start({
    apiKey: "9520852957634764dbb58d4fa20aa113",
    plugins: [new BugsnagPluginVue()]
  });

  const bugsnagVue = Bugsnag.getPlugin("vue");
  bugsnagVue.installVueErrorHandler(Vue);
}

// import VueViewer from "v-viewer";
// import VuePapaParse from "vue-papa-parse";

import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./Mixins/filters";

// import "viewerjs/dist/viewer.css";
import "vue-tel-input/dist/vue-tel-input.css";
import "./assets/css/tailwind.css";

import "@shopify/polaris/build/esm/styles.css";

Vue.config.productionTip = false;

window.serverURL = process.env.VUE_APP_SERVER_URL;

Vue.use(Vuelidate);
// Vue.use(VueViewer);
Vue.directive("linkified", linkify);
// Vue.use(VuePapaParse);

onCLS(console.log);
onFID(console.log);
onLCP(console.log);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
